import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  FLAG_GETTING_CABIN_CREW_BUS_ASSIGNMENTS,
  GET_CABIN_CREW_BUS_ASSIGNMENTS,
  CLEAR_CABIN_CREW_BUS_ASSIGNMENTS,
  FLAG_CABIN_CREW_BUS_ASSIGNMENT_ACTIVITY,
  GET_CABIN_CREW_BUS_ASSIGNMENT,
  CLEAR_CABIN_CREW_BUS_ASSIGNMENT,
  CABIN_CREW_BUS_ASSIGNMENT_INITIAL_VALUES,
} from '../../../actions/types/traffic';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
  initialValues: {},
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_CABIN_CREW_BUS_ASSIGNMENTS:
      return state.setIn(['all', 'loading'], payload);
    case GET_CABIN_CREW_BUS_ASSIGNMENTS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_CABIN_CREW_BUS_ASSIGNMENTS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_CABIN_CREW_BUS_ASSIGNMENT_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_CABIN_CREW_BUS_ASSIGNMENT:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_CABIN_CREW_BUS_ASSIGNMENT:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case CABIN_CREW_BUS_ASSIGNMENT_INITIAL_VALUES:
      return state.setIn(['initialValues'], payload);
    default:
      return state;
  }
};
